<div [formGroup]="form">
  <ds-form-control-container [labelText]="" [control]="optionCtrl">
    <select class="icon fill" formControlName="optionSelected" (change)="selectOption()">
      <option value="" selected disabled></option>
      @for (option of options; track option) {
        <option [value]="option">{{ option }}</option>
      }
    </select>
    <span class="icon-chevron-down"></span>
  </ds-form-control-container>
</div>
